// Must be imported first — patches Node.prototype before React touches the DOM.
import './lib/translateGuard'

import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Initialize i18n
import './lib/i18n'
import { initErrorTracker } from './lib/errorTracker'
import { readLastReloadAt, recordReloadAttempt, shouldReloadOnPreloadError } from './lib/preloadRecovery'

initErrorTracker();

// Vite dispatches `vite:preloadError` for ANY failed dynamic import (build's
// __vitePreload wrapper), not just React.lazy route chunks. Inert in dev
// (Vite only wraps imports in a production build); verify with `vite preview`
// + a deleted chunk.
window.addEventListener('vite:preloadError', () => {
  const shouldReload = shouldReloadOnPreloadError({
    online: navigator.onLine,
    lastReloadAt: readLastReloadAt(),
    now: Date.now(),
  })

  if (!shouldReload) return

  recordReloadAttempt(Date.now())
  // Deliberately NOT `preventDefault()`: Vite's `__vitePreload` wraps the whole
  // `import().then(m => ({ default: m.X }))` factory and, when the event is
  // default-prevented, swallows the error and resolves `undefined`. React.lazy
  // then stores `_result = undefined` and crashes on `_result.default` —
  // "Cannot read properties of undefined (reading 'default')" — which the
  // LazyLoadErrorBoundary can't recognise as a chunk miss, so it flashes the
  // "real crash" screen and fires a false auto-report while the reload is
  // already under way. Letting the original ChunkLoadError propagate keeps the
  // boundary on the upgrade screen (no auto-report) until the reload lands.
  window.location.reload()
})

createRoot(document.getElementById("root")!).render(<App />);
